<template>
	<div class="container">
		<footer>
			<div class="row">
				<div class="col-lg-12">
					
					<ul class="list-unstyled">
					</ul>
					<p><b>dpn.freeband.digital</b></p>
					<ul class="list-unstyled">

					</ul>
					<p><b>Versions:</b> Core: {{ version.core }} / Web: {{ version.web }} / <router-link to="/version">Check</router-link></p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
	export default {
		created() {
			// get core version
			this.$http.get('core/version').then(response => {
				this.version.core = response.body.core;
			});

			// get web version
			let pkg = require('../../../package.json');
			this.version.web = pkg.version;
		},
		data() {
			return {
				version: {
					core: 'Unknown',
					web: 'Unknown'
				}
			};
		}
	};
</script>

<style scoped>
	@media (min-width: 768px) {
		footer {
			margin: 2em 0;
		}

		footer li {
			float: left;
			margin: 0 1.5em 1.5em 0;
		}

		footer p {
			clear: left;
			margin-bottom: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// Footer.vue?8ed0c0e2